import { makeStyles } from '@mui/styles';
import slick from 'slick-carousel/slick/slick.css?inline';
import slickTheme from 'slick-carousel/slick/slick-theme.css?inline';
import parseCssToJss from '../../utils/parseCssToJss';
const slickSliderWrapperStyles = makeStyles(() => ({
    root: {
        ...parseCssToJss(slick),
        ...parseCssToJss(slickTheme),
    },
}), { name: 'Cmn_SlickSliderWrapper' });
export default slickSliderWrapperStyles;
//# sourceMappingURL=slickSliderWrapper.styles.js.map